import uuidv1 from 'uuid/v1';

// HEAD DATA
export const headData = {
  title: 'Ti Jiang', // e.g: 'Name | Developer'
  lang: '', // e.g: en, es, fr, jp
  description: 'Welcome to my website', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: '',
  name: 'Ti Jiang',
  subtitle: 'I am a Software Engineer',
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.jpg',
  paragraphOne: 'Software Engineer in Amazon Web Service.',
  paragraphTwo: 'Alumni of Northeastern University and Nankai University.',
  paragraphThree: '👾👾👾👾👾👾',
  resume: 'https://www.tijiang.xyz/documents/CV.pdf', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: uuidv1(),
    img: 'project.jpg',
    title: 'Will be updated soon...',
    info: 'Will be updated soon...',
    info2: 'Will be updated soon...',
    url: '',
    repo: '', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: 'Would you like to know me more? Terrific!',
  btn: '',
  email: 'jiangti2012@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: uuidv1(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/ti-jiang/',
    },
    {
      id: uuidv1(),
      name: 'github',
      url: 'https://github.com/cooljt',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
